{
  "name": "@ns/approval",
  "version": "1.0.0",
  "authorable": true,
  "description": "Someone approves or rejects what the node's config shows them, with a comment.",
  "inputs": {
    "CONFIG": {
      "type": "object"
    }
  },
  "outcomes": {
    "approve": {
      "inputs": {
        "ANSWERS": {
          "type": "object"
        }
      }
    },
    "reject": {
      "inputs": {
        "ANSWERS": {
          "type": "object"
        }
      }
    }
  },
  "config": {
    "summary": {
      "kind": "list",
      "label": "What's being approved",
      "of": {
        "label": {
          "kind": "text",
          "label": "Label",
          "required": true
        },
        "value": {
          "kind": "ref",
          "label": "Shows",
          "required": true
        }
      }
    },
    "instructions": {
      "kind": "longText",
      "label": "Instructions"
    },
    "commentOnReject": {
      "kind": "boolean",
      "label": "Comment required on reject",
      "default": true
    }
  },
  "answers": {
    "approve": {
      "comment": {
        "kind": "longText"
      }
    },
    "reject": {
      "comment": {
        "kind": "longText",
        "requiredIf": "commentOnReject"
      }
    }
  }
}
